import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (user.role === 'platform_owner') navigate('/owner');
        else if (user.role === 'introducer') navigate('/introducer-dashboard');
        else if (user.role === 'service_partner') navigate('/partner/portal');
        else navigate('/dashboard');
      } catch { navigate('/login'); }
    } else {
      navigate('/login');
    }
  }, [navigate]);
  return null;
}
